import React from 'react';
import PropTypes from 'prop-types';
import AppBar from './AppBar.jsx';
import Toolbar from './Toolbar.jsx';
import IconButton from './IconButton.jsx';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from './Typography.jsx';
import Breadcrumbs from './Breadcrumbs.jsx';
import Hidden from './Hidden.jsx';
import Link from './Link.jsx';
import Spacer from './Spacer.jsx';
import CrumbSeparator from './CrumbSeparator.jsx';
import styles from "../styles/styles.js";
const { makeStyles, useTheme } = styles;
import classnames from 'classnames';

function NavBar(props) {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <div className={classes.root}>
      <AppBar position={"fixed"} className={classes.appBar}>
        <Toolbar style={{ paddingRight: 18, paddingLeft: 18 }} className={props.containerClass}>
          {
            !!props.menu && (
              <Hidden mdUp>
                <IconButton
                  classes={{ colorPrimary: classes.icon }}
                  onClick={props.onMenuClick}
                  edge="start"
                  className={classes.menuButton}
                  aria-label="menu">
                  <MenuIcon fill={theme.palette.primary.main}/>
                </IconButton>
              </Hidden>
            )
          }
          <div className={classnames(classes.logoContainer, props.logoClass)}>
            <a href={'/'} data-testid={props['logo-testid']}>
              { props.logo }
            </a>
          </div>
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<CrumbSeparator/>}>
            {
              !!props.breadcrumb && (
                Array.isArray(props.breadcrumb)
                  ? props.breadcrumb.map(
                  (crumb) => (
                    <Link color={'textSecondary'} key={crumb.link} href={crumb.link}>
                      {crumb.title}
                    </Link>
                  )
                  )
                  : (
                    <Link color={'textSecondary'} key={props.breadcrumb.link} href={props.breadcrumb.link}>
                      {props.breadcrumb.title}
                    </Link>
                  )
              )
            }
            {
              !!props.title && (
                <Typography variant="subtitle1" className={classes.title}>
                  {props.title}
                </Typography>
              )
            }
          </Breadcrumbs>

          <Spacer/>
          {props.children}
        </Toolbar>
      </AppBar>
    </div>
  )
}

NavBar.propTypes = {
  onMenuClick: PropTypes.func,
  menu: PropTypes.bool,
  logo: PropTypes.node,
  title: PropTypes.string,
  breadcrumb: PropTypes.oneOfType([
    PropTypes.array, PropTypes.object
  ]),
  logoClass: PropTypes.string,
  containerClass: PropTypes.string
};

NavBar.defaultProps = {
  logoClass: '',
  containerClass: '',
}

const useStyles = makeStyles(theme => ({
  root: {},
  menuButton: {
    marginRight: 0,
    color: theme.palette.primary.main,
    fill: theme.palette.primary.main,
  },
  title: {
    textAlign: 'start',
    flexGrow: 1,
    fontWeight: 'bold',
    color: theme.palette.primary.main
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      width: theme.dimens.drawerWidth,
      height: 64,
      zIndex: 101
    }
  },
  logo: {
    marginRight: theme.spacing(2),
    height: 30,
    paddingTop: 5
  },
  appBar: {
    zIndex: 99,
    backgroundColor: '#ffffff',
    // color: 'white'
  },
  icon: {
    color: theme.palette.primary.main
  }
}));

export default NavBar;